import { LoanCarScheduleStatusPipe } from './loan-car-schedule.status.pipe';

export function LoanStatus ( loanCarScheduleStatusPipe : LoanCarScheduleStatusPipe ) {
  return ( value : string ) : string => loanCarScheduleStatusPipe.transform(value);
}
